export default __webpack_public_path__ + "static/media/section3-img6.9a44bfd1.png";